import Phaser from 'phaser';
import { SERVICES_KEY } from '@/core/GameServices';

export class BootScene extends Phaser.Scene {
  private prompt!: Phaser.GameObjects.Text;
  private ready = false;

  constructor() {
    super({ key: 'Boot' });
  }

  preload(): void {
    // Placeholder — asset loading goes here as assets are added
  }

  create(): void {
    const { width, height } = this.scale;

    this.add
      .text(width / 2, height / 2 - 40, 'BIOMASS', {
        fontSize: '48px',
        color: '#9cff9c',
        fontFamily: 'monospace',
      })
      .setOrigin(0.5);

    this.add
      .text(width / 2, height / 2 + 20, 'Arc 0 — The Undercity', {
        fontSize: '20px',
        color: '#666',
        fontFamily: 'monospace',
      })
      .setOrigin(0.5);

    this.prompt = this.add
      .text(width / 2, height - 40, 'loading…', {
        fontSize: '14px',
        color: '#444',
        fontFamily: 'monospace',
      })
      .setOrigin(0.5);

    this.input.keyboard?.on('keydown', () => this.tryStart());
    this.input.on('pointerdown', () => this.tryStart());
    this.waitForServices();
  }

  private waitForServices(): void {
    if (this.game.registry.has(SERVICES_KEY)) {
      this.ready = true;
      this.prompt.setText('press any key to begin');
      return;
    }
    this.time.delayedCall(50, () => this.waitForServices());
  }

  private tryStart(): void {
    if (!this.ready) return;
    this.scene.start('UnderCity');
  }
}
